import { Injectable } from '@angular/core';
import {SessionProviderService} from "../session-provider/session-provider.service";
import {AppConfigService} from "../app-config/app-config.service";
import {HttpService} from "../../rest/http-service/http.service";

@Injectable({
    providedIn: 'root'
})
export class UisService {

    errorMsg: string;

    constructor( private httpService: HttpService<any>, private sessionProviderService: SessionProviderService, private _appConfigService: AppConfigService ) { }

    sendEvent(name: string) {
        this.sendUISEvent(name, {});
    }

    sendUISEvent(eventType: string, eventParams: any) {
        //Disable events until implemented properly
        return;
    }

    getDate() {
        return (new Date()).toISOString();
    }

    onSuccess(res: any) {

    }

    UIS_EVENT_TYPES = {
        NAVIGATE_IN_HIERARCHY: 'Navigate in hierarchy',
        THEME_CHANGE: 'Theme change to - ',
        PAGE_LOADED: 'Page loaded',
        LOGIN_PAGE_LOADED: 'Login page loaded',
        LOGIN_CLICKED: 'Login button clicked',
        RESOURCE_ACTION_CLICKED: 'Resource action clicked',

        BREADCRUMBS_NAVIGATION: 'Breadcrumbs navigation',

        OPEN_CREATE_RESOURCE_FORM: 'Open create resource with form',
        CREATE_RESOURCE_WITH_FORM_SUCCESS: 'Create resource with form successfully',
        CREATE_RESOURCE_WITH_FORM_FAILED: 'Create resource with form failed',
        OPEN_EDIT_RESOURCE_FORM: 'Open edit resource with form',
        EDIT_RESOURCE_WITH_FORM_SUCCESS: 'Edit resource with form successfully',
        EDIT_RESOURCE_WITH_FORM_FAILED: 'Edit resource with form failed',

        OPEN_CREATE_RESOURCE_YAML: 'Open create resource with YAML',
        CREATE_RESOURCE_WITH_YAML_SUCCESS: 'Create resource with YAML successfully',
        CREATE_RESOURCE_WITH_YAML_FAILED: 'Create resource with YAML failed',
        OPEN_EDIT_RESOURCE_YAML: 'Open edit resource with YAML',
        EDIT_RESOURCE_WITH_YAML_SUCCESS: 'Edit resource with YAML successfully',
        EDIT_RESOURCE_WITH_YAML_FAILED: 'Edit resource with YAML failed',

        CANCEL_DIALOG: 'Cancel',

        OPEN_DELETE_RESOURCE: 'Open delete resource dialog',
        CONFIRM_DELETE_RESOURCE: 'Confirm delete resource',

        OPEN_FCL_DETAILS: 'Open FCL details',
        CLOSE_FCL_DETAILS: 'Close FCL details',
        FCL_LAYOUT_SIZE_CLICKED: 'FCL layout size clicked',
        FCL_PUBLISH_CLICKED: 'FCL publish clicked',
        FCL_IMPORT_CLICKED: 'FCL import clicked',
        HEADER_HELP_CLICKED: 'Header basic help clicked',
        HEADER_WORKSPACE_HELP_CLICKED: 'Header workspace help clicked',
        HEADER_LOGOUT_CLICKED: 'Header logout clicked',
        HEADER_SUPPORT_CLICKED: 'Header support clicked',
        HEADER_ABOUT_CLICKED: 'Header about clicked',
        HEADER_USER_INFO_CLICKED: 'Header user info clicked',
        SIDE_PAGE_CLICK: 'Page clicked from side nav',
        SIDE_ORGANIZATION_CLICK: 'Organization clicked from side nav',
        SIDE_CREATE_ORGANIZATION_CLICKED: 'Create organization clicked from side nav',
        CREATE_PUBLISH_CONFIGURATION: 'Create publish configuration',
        HEADER_HELP_DROPDOWN_CLICKED: 'Header help dropdown clicked',
        SUPPORT_LINK_CLICKED: 'Support link clicked',
        CLI_DOWNLOAD_CLICKED: 'CLI download link clicked',
        INFO_HELP_CLICKED: 'Info help clicked',
        OPEN_POLICIES_TAB: 'Open policies tab action clicked',
        OPEN_DETAILS_TAB: 'Open details tab action clicked',
        SELECT_POLICIES_TAB: 'Select Policies tab',
        SELECT_DETAILS_TAB: 'Select Details tab',
        SELECT_YAML_TAB: 'Select YAML tab',
        COPY_YAML: 'Copy YAML',
        COPY_PATH: 'Copy Path in Create/Edit with YAML',
        OPEN_CONFIGURE_TABLE_COLUMNS: 'Open configure table columns',
        SAVE_CONFIGURE_TABLE_COLUMNS: 'Save configured table columns'
    };
}
